import { render } from "./Bitacora-App.vue?vue&type=template&id=3e585135&scoped=true"
import script from "./Bitacora-App.vue?vue&type=script&lang=js"
export * from "./Bitacora-App.vue?vue&type=script&lang=js"

import "./Bitacora-App.vue?vue&type=style&index=0&id=3e585135&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e585135"]])

export default __exports__